import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
var ExusUserSourceContext = /*#__PURE__*/createContext({});
export var ExusUserSourceProvider = function ExusUserSourceProvider(_ref) {
  var fetchUserSource = _ref.fetchUserSource,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ExusUserSourceContext.Provider, {
    value: {
      fetchUserSource: fetchUserSource
    }
  }, children);
};
export var useUserSource = function useUserSource(accountId, existingSources) {
  var _useContext = useContext(ExusUserSourceContext),
      fetchUserSource = _useContext.fetchUserSource;

  var _useState = useState(new Set(existingSources)),
      _useState2 = _slicedToArray(_useState, 2),
      sources = _useState2[0],
      setUserSources = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var abortController = useMemo(function () {
    if (typeof AbortController === 'undefined') {
      return;
    }

    return new AbortController();
  }, []);
  useEffect(function () {
    var isMounted = true;

    var cleanup = function cleanup() {
      abortController === null || abortController === void 0 ? void 0 : abortController.abort();
      isMounted = false;
    };

    if (!fetchUserSource) {
      setLoading(false);
      return cleanup;
    }

    if (isMounted) {
      fetchUserSource(accountId, abortController === null || abortController === void 0 ? void 0 : abortController.signal).then(function (externalSources) {
        setLoading(false);
        var externalSourceTypes = externalSources.map(function (source) {
          return source.sourceType;
        });
        setUserSources(new Set([].concat(_toConsumableArray(sources), _toConsumableArray(externalSourceTypes))));
      }).catch(function (error) {
        setLoading(false);
        setError(error);
      });
    }

    return cleanup;
  }, [fetchUserSource, accountId, sources, abortController]);
  return {
    sources: Array.from(sources),
    loading: loading,
    error: error
  };
};